export const heatingTypes = ['oil', 'gas', 'electro'];
